<template>
<div class="ranking np-marketing-analysis">
    <div class="total bgc">
        <div class="right">
            <div class="filters bgc">
                <div class="add">
                    <!--<el-button type="danger" @click="handleQuery(1)" :class="[param.timetype!=1?'is-disabled': '']">今天</el-button>-->
                    <!--<el-button type="primary" @click="handleQuery(2)" :class="[param.timetype!=2?'is-disabled': '']">昨天</el-button>-->
                    <!--<el-button type="success" @click="handleQuery(3)" :class="[param.timetype!=3?'is-disabled': '']">近7天</el-button>-->
                    <!--<el-button type="warning" @click="handleQuery(4)" :class="[param.timetype!=4?'is-disabled': '']">近30天</el-button>-->
                </div>
                <div class="search">
                    <div class="flexstart datacount">显示条数：<el-input v-model="param.datacount" placeholder="请输入显示条数" class="condition" clearable></el-input></div>
                    <el-select v-model="param.ranktype" placeholder="邀请排行榜" class="condition" clearable>
                        <el-option v-for="item in ranktypeList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
                    </el-select>
                    <el-select v-model="param.statetype" placeholder="按全部统计" class="condition" clearable>
                        <el-option v-for="item in statetypeList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
                    </el-select>
                    <el-date-picker class="dateInput" v-model="date" type="daterange" align="right" unlink-panels
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <el-button type="primary" @click="handleQuery(0)">确认筛选</el-button>
                    <el-button type="success" @click="handleExport">下载表格</el-button>
                </div>
            </div>
            <div class="list">
                <div class="dateTime blod"><span class="blod">{{summaryinfo.begindate}}</span> 至 <span class="blod">{{summaryinfo.enddate}}</span></div>
                <div class="result-list btn-operate-list bgc">
                    <div class="lengdeList">
                        <span class="lengdeName" style="width: 5%">排名</span>
                        <span v-for="(obj,index) in lengdeName" :key="index" class="lengdeName" :style="'width:'+(95/lengdeName.length)+'%'">{{obj}}</span>
                    </div>
                    <div class="tableData">
                        <div v-for="(obj,index) in tableData" :key="index" class="outbox">
                            <div class="box" style="width: 5%"><span class="innerbox">{{index+1}}</span></div>
                            <div v-for="(obj2,index) in obj" :key="index" class="box" :style="'width:'+(95/lengdeName.length)+'%'">
                                <span class="innerbox">{{obj2.nickname}}</span>
                                <span class="innerbox">{{obj2.datacount}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
import {getDataStatisticsByRank, exportDataStatisticsByRank} from 'api/nationalDistribution'
export default {
    name: 'ranking',
    data() {
        return {
            init: false,
            tableData: [],
            summaryinfo: {
                begindate: '',
                enddate: ''
            },
            date: [],
            datatype: 6, // 1用户统计 2订单统计 3财务统计 4分享统计 5裂变统计 6排行榜
            param: {
                timetype: 0, // 时间类型 0自定义 1今日 2昨日 3近7日 4近30日
                eventinnerid: '',
                ranktype: 1, // 排名类型 1佣金 2邀请数
                statetype: 1, // 统计类型 1全部 2按日
                datacount: 10, // 显示数据条数
                begindate: '',
                enddate: ''
            },
            ranktypeList: [
                {code: 1, name: '佣金排行'},
                {code: 2, name: '邀请排行'}
            ],
            statetypeList: [
                {code: 1, name: '按全部统计'},
                {code: 2, name: '按日统计'}
            ],
            lengdeName: [],
            userinfo: {
                viewcount: '', // 总浏览量PV
                uviewcount: '', //  参与人数UV
                avgviewcount: '' //  平均浏览量=总浏览量PV/参与人数UV
            }
        }
    },
    mounted() {
        let date = new Date()
        let [y, m, d] = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
        this.param.begindate = y + '-' + m + '-' + d
        this.param.enddate = y + '-' + m + '-' + d
        this.date = [this.param.begindate, this.param.enddate]
    },
    methods: {
        indexMethod(index) {
            return index + 1
        },
        handleQuery(index) {
            if (!index && !this.date.length) {
                this.$message.error('请选择筛选日期')
                return false
            } else if (!index && !!this.date.length) {
                this.param.begindate = this.date[0]
                this.param.enddate = this.date[1]
            }
            this.param.timetype = index
            this._getTotal()
        },
        getTotal(param) {
            this.param.eventinnerid = param.eventinnerid
            if (!this.init) {
                this._getTotal()
            }
        },
        handleExport() {
            this.setLoading(true)
            exportDataStatisticsByRank({
                data: this.param,
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '排行榜数据' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getTotal() {
            this.setLoading(true)
            getDataStatisticsByRank({
                data: this.param,
                success: data => {
                    this.lengdeName = []
                    this.tableData = []
                    this.summaryinfo = data.data.summaryinfo
                    data.data.datalist.forEach((obj) => {
                        this.lengdeName.push(obj.date)
                    })
                    for (let i = 0; i < this.param.datacount; i++) {
                        let list = []
                        for (let j = 0; j < data.data.datalist.length; j++) {
                            if (i < data.data.datalist[j].rankdata.length) {
                                list.push(data.data.datalist[j].rankdata[i])
                                console.log(data.data.datalist[j].rankdata[i])
                            } else {
                                list.push({})
                            }
                        }
                        this.tableData.push(list)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.ranking{
    .total{
        height: auto !important;
    }
    .list{
        margin-top: 0;
    }
    .datacount{
        .el-input, .el-input__inner{
            width: 80px !important;
            box-sizing: border-box;
        }
    }
    .lengdeList{
        border-top: 1px solid $line;
        border-left: 1px solid $line;
        border-right: 1px solid $line;
        display: flex;
        background: #FAFAFA;
        .lengdeName{
            padding: 12px 10px;
            box-sizing: border-box;
            overflow: hidden;
        }
        .lengdeName+ .lengdeName{
            border-left: 1px solid $line;
        }
    }
    .tableData{
        border: 1px solid $line;
        .outbox{
            display: flex;
            .box{
                display: flex;
                overflow: hidden;
                .innerbox{
                    padding: 12px 10px;
                    width: 50%;
                    box-sizing: border-box;
                }
                .innerbox+ .innerbox{
                    border-left: 1px solid $line;
                }
            }
            .box+ .box{
                border-left: 1px solid $line;
            }
        }
        .outbox+.outbox{
            border-top: 1px solid $line;
        }
        .outbox:hover{
            background: #f5f7fa;
        }
    }
}
</style>
